import React, { Component } from 'react'
import { Card, Pagination, Container, Row, Col } from 'react-bootstrap'
import { Navigation } from './Navigation'
import { Footer } from './Footer'

// Importación de imágenes
import img42 from './EquipoMedico/img42.jpg'
import img43 from './EquipoMedico/img43.jpg'
import img44 from './EquipoMedico/img44.jpg'
import img45 from './EquipoMedico/img45.jpg'
import img46 from './EquipoMedico/img46.jpg'
import img47 from './EquipoMedico/img47.jpg'
import img48 from './EquipoMedico/img48.jpg'
import img49 from './EquipoMedico/img49.jpg'
import img50 from './EquipoMedico/img50.jpg'
import img51 from './EquipoMedico/img51.jpg'
import img52 from './EquipoMedico/img52.jpg'
import img53 from './EquipoMedico/img53.jpg'
import img54 from './EquipoMedico/img54.jpg'
import img55 from './EquipoMedico/img55.jpg'
import img56 from './EquipoMedico/img56.jpg'
import img57 from './EquipoMedico/img57.jpg'
import img58 from './EquipoMedico/img58.jpg'
import img59 from './EquipoMedico/img59.jpg'

export class Insumo3 extends Component {
    render() {
        // Listado de productos extraído de tu código original
        const productos = [
            { id: 42, titulo: "Hisopos de Madera estéril", img: img42, desc: "Caja de 100 Unidades" },
            { id: 43, titulo: "Hojas de Bisturi", img: img43, desc: "" },
            { id: 44, titulo: "I.V Cateter", img: img44, desc: "" },
            { id: 45, titulo: "I.V Cateter", img: img45, desc: "" },
            { id: 46, titulo: "I.V Cateter Mariposa", img: img46, desc: "" },
            { id: 47, titulo: "I.V Cateter", img: img47, desc: "" },
            { id: 48, titulo: "Jeringa descartable de insulina", img: img48, desc: "Empaque Individual" },
            { id: 49, titulo: "Jeringa descartable 3 cc, 5 cc, 10 cc", img: img49, desc: "Empaque Individual" },
            { id: 50, titulo: "Nelaton Cateter", img: img50, desc: "" },
            { id: 51, titulo: "Parches Oculares", img: img51, desc: "" },
            { id: 52, titulo: "Sonda Foley", img: img52, desc: "" },
            { id: 53, titulo: "Sonda Rectal", img: img53, desc: "" },
            { id: 54, titulo: "Suturas quirúrgicas", img: img54, desc: "De Nylon, seda, catgut crómico, catgut simple, polipropileno, poliéster trenzado, ácido coliglicólico." },
            { id: 55, titulo: "Termometros", img: img55, desc: "" },
            { id: 56, titulo: "Tubos Endotraqueles", img: img56, desc: "" },
            { id: 57, titulo: "Tubos Endotraqueales", img: img57, desc: "" },
            { id: 58, titulo: "Tubos Endotraqueales", img: img58, desc: "" },
            { id: 59, titulo: "Tubos Endotraqueales", img: img59, desc: "" }
        ];

        return (
            <div>
                <Navigation />
                <br />
                <h1 className="text-center">Insumo medico</h1>
                <Container className="mt-4">
                    
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/insumo">{1}</Pagination.Item>
                        <Pagination.Item href="/insumo2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>

                    {/* Reemplazo de CardDeck por Row con Grid dinámico */}
                    <Row xs={1} md={2} className="g-4 mb-4">
                        {productos.map((prod) => (
                            <Col key={prod.id}>
                                <Card className="h-100 shadow-sm">
                                    <Card.Header><h5>Productos descartables</h5></Card.Header>
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col xs={7}>
                                                <Card.Title className="color-texto">{prod.titulo}</Card.Title>
                                                {prod.desc && (
                                                    <Card.Text style={{ fontSize: '0.9rem' }}>
                                                        {prod.desc}
                                                    </Card.Text>
                                                )}
                                            </Col>
                                            <Col xs={5}>
                                                <Card.Img variant="top" src={prod.img} alt={prod.titulo} />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/insumo">{1}</Pagination.Item>
                        <Pagination.Item href="/insumo2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                </Container>
                <Footer />
            </div>
        )
    }
}